import {
  RECEIVE_SF_FIELD_DATA,
  SET_FORM,
} from '../constants';
import {
  makeSelectFields,
  makeSelectSalesForceData,
} from '../selectors';
import { loadDropdownHandler } from '../asyncfields';

/**
 * Middleware to handle RECEIVE_SF_FIELD_DATA and SET_FORM actions
 * Converts the saga-based dropdown watcher to middleware
 *
 * The middleware:
 * 1. Intercepts RECEIVE_SF_FIELD_DATA and SET_FORM actions
 * 2. Gets all fields from state and SF data selectors
 * 3. Calls the synchronous loadDropdownHandler
 * 4. Dispatches the returned actions in order
 */
export default function loadDropdownMiddleware(storeAPI) {
  return (next) => (action) => {
    // Pass the action through first
    const result = next(action);

    // If it's a field data or form action
    if (action.type === RECEIVE_SF_FIELD_DATA || action.type === SET_FORM) {
      const state = storeAPI.getState();

      // Get all fields from state
      const fieldsSelector = makeSelectFields();
      const allFields = fieldsSelector(state);

      // Create a function to get SF data for a specific field name
      const getSalesForceData = (fieldName) => {
        const sfDataSelector = makeSelectSalesForceData(fieldName);
        return sfDataSelector(state);
      };

      // Call the synchronous handler
      const actions = loadDropdownHandler(allFields, getSalesForceData);

      // Dispatch all returned actions in order
      actions.forEach((a) => {
        storeAPI.dispatch(a);
      });
    }

    return result;
  };
}
